<template>
  <b-card title="لیست پیام های گزارش شده">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="2">
                <b-form-group
                    label="شناسه کاربر"
                >
                  <b-form-input
                      v-model="filterOptions.UserId"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="توضیحات"
                >
                  <b-form-input
                      v-model="filterOptions.Description"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label=" از تاریخ"
                >
                  <date-picker
                      v-model="filterOptions.FromDate"
                      placeholder=""
                      clearable
                  />
                </b-form-group>
              </b-col>
              <b-col  md="2">
                <b-form-group
                    label=" تا تاریخ"
                >
                  <date-picker
                      v-model="filterOptions.ToDate"
                      placeholder=""
                      clearable
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label=" وضعیت"
                >
                  <v-select
                      v-model="filterOptions.MessageReportStatus"
                      label="title"
                      :reduce="x => x.value"
                      :options="[
                          {value:0,title:'نقض قوانین'} ,
                          {value:1,title:'بدون اشکال'},
                          {value:2,title:'گزارش مجدد'},
                          {value:3,title:'در حال بررسی'},
                      ]"
                  ></v-select>
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="warning"
                  @click="update(1)"
                  class="mb-1 mr-1"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>
        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
            :no-local-sorting="true"
        >
          <template #cell(Name)="data">
            <b-link :to="{ name: 'userDetail', params: { id: data.item.UserId }}" target="_blank">
              <b-media
                  vertical-align="center"
                  style="align-items: center;"
              >
                <template #aside>
                  <b-avatar
                      :src="data.item.Image"
                  />
                </template>
                <span
                    class="font-weight-bold d-block text-nowrap"
                    style="color: #6e6b7b;"
                >
                  <template v-if="data.value ">{{ data.value }}</template>
                  <template v-else>کاربر زیره</template>
                </span>
                <small class="text-muted">{{ data.item.UserId }}</small>
              </b-media>
            </b-link>
          </template>
          <template #cell(Reporter)="data">
            <b-badge
                  v-for="item in data.item.MessageReport"
                  :key="item.UserId"
                  style="margin: 0 0 5px 5px"
                  v-b-tooltip.hover.top="item.Description"
              >
              <b-link
                  class="d-block"
                  :to="{ name: 'userDetail', params: { id: item.UserId }}"
                  target="_blank"
              >
                <span> {{ item.Name}} </span>
              </b-link>
              </b-badge>
          </template>
          <template #cell(MessageReportStatus)="data">
            <b-badge
                class="mb-1"
                :variant="enums('MessageReportStatus', 'value', data.value, 'badge')">
              {{ enums('MessageReportStatus', 'value', data.value, 'title') }}
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                  @click="edit(data.item)"
              />
              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />
      </b-col>
    </b-row>
    <message-report-item :key="Math.floor(Math.random() * 100)" :show.sync="showModal" :item="editingItem" @done="update" />
  </b-card>
</template>

<script>
import MessageReportItem from "./messageReportItem.vue";

export default {
  name: 'messageReports',
  components: { MessageReportItem },
  data() {
    return {
      loading: false,
      showModal: false,
      editingItem: null,
      filterOptions: {
        UserId:null,
        Description:null,
        FromDate:null,
        ToDate:null,
        MessageReportStatus:3,
        Page: 1,
        PerPage: 10,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Name',
          label: 'نام',
        },

        {
          key: 'MessageText',
          label: 'پیام',
        },
        {
          key: 'Reporter',
          label: 'گزارش دهنده',
        },
        {
          key: 'ReportCount',
          label: 'دفعات گزارش شده',
        },
        {
          key: 'MessageReportStatus',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      totalRows:10
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.get(this.$api.messenger.messageReportList, { params: this.filterOptions })
          .then(res => {
            this.totalRows= res?.totalRow || 10
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    remove(id) {
      this.$bvModal.msgBoxConfirm('آیا مطمئن هستید که می خواهید این مورد را حذف کنید؟', {
        title: 'حذف',
        size: 'sm',
        okVariant: 'danger',
        okTitle: 'تایید',
        cancelTitle: 'انصراف',
        cancelVariant: 'outline-secondary',
        hideHeaderClose: false,
        centered: true,
        modalClass: 'modal-danger modal-remove-confirm',
      }).then(confirm => {
        if (confirm) {
          this.$http.post(this.$api.messenger.removeMessageReport, { MessageId: id }).then(() => {
            this.update()
          })
        }
      })
    },
    edit(item) {
      this.editingItem = item
      this.showModal= true
    }
  }
}
</script>
